import { motion } from "framer-motion";
import { ReactComponent as AboutMission } from "../../../../../images/web/about/about-mission-svg.svg";
import Constaint from "../../../layout/components/Constaint";

const PILLARS = [
  { value: "50+", label: "Countries Served" },
  { value: "10k+", label: "Applications Processed" },
  { value: "97%", label: "Approval Rate" },
];

const Mission = () => {
  return (
    <Constaint>
      <section className="relative overflow-hidden w-full">
        <div className="flex flex-col-reverse lg:flex-row lg:items-stretch lg:min-h-[620px]">
          {/* SVG — column on mobile, left panel on desktop */}
          <div className="relative w-full lg:w-2/5 min-h-64 lg:min-h-0 overflow-hidden">
            <AboutMission className="h-full w-full" />
          </div>

          {/* Content */}
          <div className="relative w-full lg:w-3/5 bg-white py-24 lg:py-32 flex items-center">
              <motion.div
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.65 }}
              >
                <p className="inline-flex rounded-full border border-blue-ea bg-white px-4 py-2 text-xs font-semibold uppercase tracking-widest text-blue-00">
                  Our Mission
                </p>

                <h2 className="mt-5 text-4xl font-light font-lato leading-tight tracking-tight text-black-1a sm:text-5xl">
                  Bridge the gap between
                  <span className="text-blue-00 italic mx-2">ambition</span>
                  and achievement
                </h2>

                <p className="mt-6 text-lg leading-8 text-dark-6b">
                  To bridge the gap between ambition and achievement for people
                  navigating the world's borders — making the journey to
                  international education, career opportunity, and global
                  belonging seamless, dignified, and within reach.
                </p>

                <div className="mt-10 grid grid-cols-3 gap-6 border-t border-grey-eb pt-8">
                  {PILLARS.map(({ value, label }) => (
                    <div key={label}>
                      <p className="text-2xl font-semibold text-blue-00 font-lato">
                        {value}
                      </p>
                      <p className="mt-1 text-sm text-dark-6b">{label}</p>
                    </div>
                  ))}
                </div>
              </motion.div>
          </div>
        </div>
      </section>
    </Constaint>
  );
};

export default Mission;
